import React from "react";
import { motion } from "framer-motion";
import { Calendar, Truck, Sparkles, Store, ArrowRight } from "lucide-react";

const posts = [
  {
    id: "blog-teslimat",
    image:
      "https://customer-assets.emergentagent.com/job_halipak-solutions/artifacts/xs6uj7j1_image.png",
    tag: "Lojistik",
    icon: Truck,
    date: "Sahadan",
    title: "Halı Yıkamacılara Hızlı Teslimat",
    excerpt:
      "HALIPAK Halı Hurcu paketleme malzemelerimiz, halı yıkama firmalarımıza Türkiye'nin dört bir yanına aynı gün içinde yola çıkıyor. Yüksek miktarlı toptan siparişlerde özel araçlarla sevkiyat yapıyoruz.",
  },
  {
    id: "blog-fuar",
    image:
      "https://customer-assets.emergentagent.com/job_halipak-solutions/artifacts/ef7act0p_image.png",
    tag: "Fuar",
    icon: Sparkles,
    date: "Sektör",
    title: "Halı Yıkama Sektörü Fuarındaydık",
    excerpt:
      "Halı yıkama sektörünün önde gelen profesyonelleriyle bir araya geldik. HALIPAK Halı Hurcu standımızda yeni ürünlerimizi ve toptan satış avantajlarımızı tanıttık.",
  },
  {
    id: "blog-kargo",
    image:
      "https://customer-assets.emergentagent.com/job_halipak-solutions/artifacts/u2vub1cn_image.png",
    tag: "Gönderim",
    icon: Store,
    date: "Türkiye Geneli",
    title: "Türkiye'nin Her Yerine Gönderim",
    excerpt:
      "Anlaşmalı kargo firmalarımız üzerinden Türkiye'nin tüm illerine güvenli ve hızlı gönderim sağlıyoruz. Siparişiniz, profesyonel paketleme ile kapınıza ulaşır.",
  },
];

const Blog = () => {
  return (
    <section
      id="blog"
      data-testid="blog-section"
      className="py-20 lg:py-28 bg-[#F8FAFC] relative overflow-hidden"
    >
      <div className="container mx-auto px-6 lg:px-8 max-w-7xl relative">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div className="max-w-3xl">
            <div className="text-xs font-bold tracking-[0.28em] uppercase text-[#2563EB]">
              Blog &amp; Galeri
            </div>
            <h2 className="mt-4 font-heading font-bold text-4xl sm:text-5xl lg:text-6xl text-[#0A192F] leading-[1.02] tracking-tight">
              Sahadan <span className="text-[#2563EB]">kareler.</span>
            </h2>
            <p className="mt-5 text-base sm:text-lg text-slate-600 max-w-2xl">
              HALIPAK olarak halı yıkama sektörünün içindeyiz. Lojistik, fuar ve müşteri
              ziyaretlerinden son gönderilerimize uzanan kısa bir kesit.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.article
                key={p.id}
                data-testid={`blog-card-${p.id}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.08 }}
                className="group relative rounded-3xl overflow-hidden bg-white border border-slate-200 hover:border-[#2563EB]/40 hover:shadow-2xl hover:shadow-[#0A192F]/10 hover:-translate-y-1 transition-all duration-300 flex flex-col"
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    draggable="false"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                  <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-white/95 backdrop-blur px-3 py-1.5 text-[11px] font-bold uppercase tracking-widest text-[#0A192F] shadow-sm">
                    <Icon className="w-3.5 h-3.5 text-[#2563EB]" />
                    {p.tag}
                  </div>
                </div>

                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-slate-500">
                    <Calendar className="w-3.5 h-3.5" />
                    {p.date}
                  </div>
                  <h3 className="mt-3 font-heading font-bold text-[#0A192F] text-xl leading-tight">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">
                    {p.excerpt}
                  </p>
                  <div className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#2563EB] group-hover:gap-3 transition-all">
                    Detay için bizi arayın
                    <ArrowRight className="w-4 h-4" />
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Blog;
